import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

const Gastenkaart = ({ gastverbruik }) => {
  const gast = gastverbruik?.gast;
  
  if (!gast) {
    return (
      <div className="box box-default">
        <div className="box-header with-border">
          <h3 className="box-title">Gastinformatie</h3>
        </div>
        <div className="box-body">
          <p className="text-muted">Geen gastinformatie beschikbaar</p>
        </div>
      </div>
    );
  }

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">Gastinformatie</h3>
        <div className="box-tools pull-right">
          <Link 
            className="btn btn-primary btn-sm" 
            to={`/gastenverbruik/gasten/${gast._id}`}
          >
            <i className="fa fa-list"></i>&nbsp; Alle boekingen
          </Link>
        </div>
      </div>
      <div className="box-body">
        <div className="row">
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Persoonlijke gegevens</h5>
                <div className="row mb-2">
                  <div className="col-4"><strong>Naam:</strong></div>
                  <div className="col-8">
                    {gast.voornaam} {gast.tussennaam} {gast.achternaam}
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-4"><strong>Email:</strong></div>
                  <div className="col-8">{gast.email}</div>
                </div>
                {gast.telefoonnummer && (
                  <div className="row mb-2">
                    <div className="col-4"><strong>Telefoon:</strong></div>
                    <div className="col-8">{gast.telefoonnummer}</div>
                  </div>
                )}
                {gast.bootnaam && (
                  <div className="row mb-2">
                    <div className="col-4"><strong>Bootnaam:</strong></div>
                    <div className="col-8">{gast.bootnaam}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Verblijfsgegevens</h5>
                {gast.gastenprofiel && (
                  <div className="row mb-2">
                    <div className="col-4"><strong>Profiel:</strong></div>
                    <div className="col-8">{gast.gastenprofiel.naam}</div>
                  </div>
                )}
                <div className="row mb-2">
                  <div className="col-4"><strong>Gast ID:</strong></div>
                  <div className="col-8">{gast.gastenid || 'Niet beschikbaar'}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4"><strong>Status:</strong></div>
                  <div className="col-8">
                    <span className={`badge ${gast.isVerified ? 'badge-success' : 'badge-warning'}`}>
                      {gast.isVerified ? 'Geverifieerd' : 'Niet geverifieerd'}
                    </span>
                    {gast.blocked && (
                      <span className="badge badge-danger ml-1">Geblokkeerd</span>
                    )}
                  </div>
                </div>
                {gast.taal && (
                  <div className="row mb-2">
                    <div className="col-4"><strong>Taal:</strong></div>
                    <div className="col-8">{gast.taal}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gastenkaart;